import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

import ActionButton from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink.js';
import ButtonCollection from '../builder/ButtonCollection';
import FloatingLayer from '../builder/FloatingLayer';
import Message from '../builder/Message.js';
import SectionSubtitle from '../builder/SectionSubtitle.js';
import SectionTitle from '../builder/SectionTitle';

const TeamEquipmentTemplateLayer = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	let sport_type = props?.sport_type ?? 'football';
	if(sport_type == 'other') sport_type = 'football';

	return (
		<FloatingLayer backButton={props.close}>
			<div class="without_actions">
				<SectionTitle>Instructions for creating the background image</SectionTitle>

				<SectionSubtitle>This is the default image that will be displayed when players do not have an image of their own. This image will be displayed under a mask. By default the mask is in the shape of a T-shirt.</SectionSubtitle>

				<SectionSubtitle autotranslate={false}><FormattedMessage id="You can change the shape of the mask from the {link} section." values={{link:<ActionLink _href={props.design_url} autotranslate={false}>{i18n("Design", 'lowercase')}</ActionLink>}} /></SectionSubtitle>

				<div class="team_shirt_template">
					<div>
						<SectionSubtitle>These instructions are intended for a graphic designer.</SectionSubtitle>

						<SectionSubtitle>They include a template in .AI format to assist in the creation of the image.</SectionSubtitle>

						<ol>
							<li>
								<p><strong>{i18n("Download the template")}</strong>:</p>

								<ButtonCollection _class={{other:'gui_not_in_top_tiny'}}>
									<ActionButton
										icon='knk-download'
										download={true}
										_href={`/img/teams/${sport_type}_shirt_template.ai`}
										_target='_blank'
									>Download template in .AI format</ActionButton>
								</ButtonCollection>
							</li>

							<li>
								<p><strong>{i18n("Create your image")}</strong>:</p>
								<ul class="bulleted_list">
									<li>{i18n("You should only work on the TEXTURE layer.")}</li>
									<li>{i18n("The GUIDES layer will help you visualize the shape of the mask, where the T-shirt number and other details will be positioned.")}</li>
									<li>{i18n("The PREVIEW layer will help you to see the final result.")}</li>
									<li>{i18n("Do not add the T-shirt number in your image, the application will add it automatically.")}</li>
								</ul>
							</li>

							<li>
								<p><strong>{i18n("Export the image to PNG / JPG")}</strong> [240 x 288px]:</p>
								<ul class="bulleted_list">
									<li><u>{i18n("You must export only the TEXTURE layer.")}</u></li>
								</ul>
							</li>
						</ol>
					</div>

					<div class="img_template">
						<div class="img_cont">
							<div class="caption">
								<p>{i18n("Example", 'uppercase')} #1: {i18n("Texture file to upload")}</p>
							</div>

							<img src={`/img/teams/${sport_type}_shirt_template.svg`} width="100%" alt="" />
						</div>

						<div class="img_cont hover_state">
							<div class="caption">
								<p>{i18n("Example", 'uppercase')} #2: {i18n("Final result")}</p>
							</div>

							<img src={`/img/teams/${sport_type}_shirt_template_hover.svg`} width="100%" alt="" />
						</div>
					</div>
				</div>
			</div>
		</FloatingLayer>
	)
};

export default injectIntl(TeamEquipmentTemplateLayer);